module.exports = __webpack_public_path__ + "cd455783/img/product-icon-grey.b248963c.svg";